import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Popover from 'components/shared/Popover'
import Tooltip from 'components/shared/Tooltip'
import TooltipText from './TooltipText'
import Picker from 'emoji-picker-react'

import iconEmoji from 'assets/icons/ico-emoji.svg'
import iconEmojiActive from 'assets/icons/ico-emoji-active.svg'

import Icon from 'components/shared/Icon'

const EmojiPickerWrapper = styled.div`
  max-width: 320px;
`

const EmojiIcon = ({ isPopoverShown }) => (
  <Icon
    src={
      isPopoverShown
        ? iconEmojiActive
        : iconEmoji
    }
  />
)
EmojiIcon.propTypes = {
  isPopoverShown: PropTypes.bool
}

const EmojiPicker = (props) => {
  const {setMessage} = props

  const handleEmojiPick = (data) => {
    setMessage(message => (message+data.emoji))
  }
    
  return (
    <Popover
      trigger={popoverProps => (
        <Tooltip
          trigger={tooltipProps => (
            <EmojiIcon {...popoverProps} {...tooltipProps} />
          )}
          type='arrow'
          position='top'
        >
          <TooltipText>Select emoji</TooltipText>
        </Tooltip>
      )}
      type='arrow'
      position='top'
    >
      <EmojiPickerWrapper>
        <Picker onEmojiClick={ (e, data) => {handleEmojiPick(data)}} />
      </EmojiPickerWrapper>
    </Popover>

  )
}

EmojiPicker.propTypes = {
  setMessage: PropTypes.func.isRequired
}

export default EmojiPicker
